import { pathOr } from 'ramda';
import { createSelector } from 'reselect';
import { i18n, MetadataConstants, MetadataSelectors } from 'invision-core';
import { RouteParams, SelectedCustomerSelector } from './customer.selectors';
import { PRODUCT_AVAILABLE_DELIVERY_CAPABILITY_ACTIONS, PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import LocaleKeys from '../../locales/keys';
import { ConvergentBillerAccountOfferingsSelector } from './customer.convergent.biller.selectors';
export var CustomerProductDetailSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.productDetail ? selectedCustomer.productDetail.data : null;
});
export var CustomerProductOrderDetailSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.productDetail ? selectedCustomer.productDetail.orderData : null;
});
export var getPoliciesWithFriendlyNames = function getPoliciesWithFriendlyNames(productDetail, deliveryCapabilities) {
  if (productDetail.ProductContext && productDetail.ProductContext.PurchasePolicies) {
    return productDetail.ProductContext.PurchasePolicies.map(function (policy) {
      if (policy.ActionCode) {
        var deliveryCapability = deliveryCapabilities.items.find(function (capability) {
          return policy.ActionCode && policy.ActionCode.toString() === capability.Value;
        });
        return policy.set('FriendlyName', deliveryCapability ? deliveryCapability.Name : '');
      } else {
        return policy;
      }
    });
  } else {
    return [];
  }
};
export var CurrentProductDetailSelector = createSelector([CustomerProductDetailSelector, MetadataSelectors.codes.MetadataCodeSelector(MetadataConstants.codes.ProductLineOfBusinessDeliveryCapabilityConfigurationAction)], function (productDetail, productLineOfBusinessDeliveryCapabilityConfigurationAction) {
  if (productDetail && productDetail.LockerItem) {
    if (productLineOfBusinessDeliveryCapabilityConfigurationAction) {
      return productDetail.LockerItem.setIn(['ProductContext', 'PurchasePolicies'], getPoliciesWithFriendlyNames(productDetail.LockerItem, productLineOfBusinessDeliveryCapabilityConfigurationAction));
    } else {
      return productDetail.LockerItem;
    }
  } else {
    return null;
  }
});
export var CanViewContentActivitySelector = createSelector([CurrentProductDetailSelector], function (productDetail) {
  return !pathOr(0, ['ProductContext', 'AvailableDeliveryCapabilityActions', 'length'], productDetail) ? false : productDetail.ProductContext.AvailableDeliveryCapabilityActions.some(function (action) {
    return action.Code === PRODUCT_AVAILABLE_DELIVERY_CAPABILITY_ACTIONS.DOWNLOAD || action.Code === PRODUCT_AVAILABLE_DELIVERY_CAPABILITY_ACTIONS.PLAYBACK;
  });
});
export var CurrentProductDetailsClassificationSelector = createSelector([CurrentProductDetailSelector], function (productDetails) {
  var classification = pathOr(null, ['Product', 'ProductClassification'], productDetails);
  if (classification) {
    switch (classification) {
      case PRODUCT_CLASSIFICATIONS.PRODUCT:
        return i18n.translate(LocaleKeys.PRODUCT);
      case PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE:
        return i18n.translate(LocaleKeys.SERVICE_FEATURE);
      case PRODUCT_CLASSIFICATIONS.AD_HOC:
        return i18n.translate(LocaleKeys.AD_HOC);
      default:
        return null;
    }
  }
  return null;
});
export var IsFetchingProductDetailDataSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.productDetail ? selectedCustomer.productDetail.isFetchingData : null;
});
export var CurrentLockerItemIdSelector = createSelector([RouteParams], function (routeParams) {
  return routeParams.lockerItemId;
});
export var CurrentLockerItemOrderIdSelector = createSelector([CurrentProductDetailSelector], function (currentProduct) {
  return currentProduct ? currentProduct.OrderId : null;
});
export var CurrentProductOrderDetailSelector = createSelector([CustomerProductOrderDetailSelector, CurrentLockerItemIdSelector], function (orderDetail, lockerItemId) {
  if (orderDetail && orderDetail.Items && orderDetail.Items.length) {
    return orderDetail.Items.find(function (item) {
      return item.LockerItemId === lockerItemId;
    });
  }
  return {};
});
export var CurrentOfferInContextSelector = createSelector([ConvergentBillerAccountOfferingsSelector, CurrentProductDetailSelector], function (offerings, productDetail) {
  var offerInContext = null;
  var currentProduct = pathOr(null, ['Product'], productDetail);
  var currentPricingPlanId = pathOr(null, ['PricingPlan', 'Id'], productDetail);
  if (offerings && offerings.length && currentProduct && currentPricingPlanId) {
    offerings.forEach(function (offering) {
      if (currentProduct.ProductClassification === PRODUCT_CLASSIFICATIONS.PRODUCT) {
        offerInContext = offering.Options.find(function (option) {
          return option.PricingPlanId === currentPricingPlanId;
        });
      }
      if (currentProduct.ProductClassification === PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE) {
        offerInContext = offering.ServiceFeatures.find(function (feature) {
          return feature.PricingPlanId === currentPricingPlanId;
        });
      }
    });
  }
  return offerInContext;
});
export var CurrentProductServiceIdSelector = createSelector([ConvergentBillerAccountOfferingsSelector, CurrentLockerItemIdSelector], function (offerings, lockerItemId) {
  var orderedServiceId = null;
  var subscriberProductId = null;
  if (offerings && offerings.length) {
    offerings.forEach(function (offering) {
      if (lockerItemId) {
        subscriberProductId = offering.ServiceFeatures.find(function (feature) {
          return feature.SubscriberProductId === lockerItemId;
        });
      }
      offering.Options.forEach(function (option) {
        if (subscriberProductId && option.ServiceAttributeValues && option.ServiceAttributeValues.length) {
          orderedServiceId = option.ServiceAttributeValues.find(function (attribute) {
            return subscriberProductId.ServiceIdentifierValue === attribute.Value;
          });
        }
      });
    });
  }
  return orderedServiceId && orderedServiceId.ServiceId ? orderedServiceId.ServiceId : null;
});